var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuickChat = function SvgQuickChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "quick-chat_svg__a",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "quick-chat_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#quick-chat_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    mask: "url(#quick-chat_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.222,
    d: "M12.14 18.218a6.68 6.68 0 0 0 6.679-6.678v-.468a6.68 6.68 0 0 0-6.679-6.679h-.44a6.24 6.24 0 0 0-6.238 6.239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 1.222,
    d: "M5.462 10.384c1.117 0 2.023.906 2.023 2.024v1.436a2.024 2.024 0 1 1-4.047 0v-1.436c0-1.118.906-2.024 2.024-2.024ZM11.09 17.043h1.696a1.175 1.175 0 0 1 0 2.35H11.09a1.175 1.175 0 0 1 0-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 1.075,
    d: "M18.414 10.384c1.118 0 2.024.906 2.024 2.024v1.436a2.024 2.024 0 1 1-4.048 0v-1.436c0-1.118.906-2.024 2.024-2.024Z"
  })))));
};
export default SvgQuickChat;